<template>
    <b-modal
        v-model="modalShow"
        class="ext-modal ext-modal--xl p-user-search"
        :title="`${$locale.patient}を検索`"
        static
        ok-only
        ok-title="キャンセル"
        ok-variant="yokumiru-gray"
        @ok="close"
        @hidden="close">
        <div class="c-freeword input-group input-group-sm mb-3">
            <input
                v-model="freeword"
                type="text"
                class="form-control"
                name="freeword"
                id="freeword"
                placeholder="フリーワード">
            <div class="input-group-append">
                <div
                    class="c-freeword__btn input-group-text"
                    @click="fetchUsers">
                    検索
                </div>
            </div>
        </div>

        <div :class="{ 'u-loader u-loader--p5' : ! users }">
            <div v-if="users">
                <b-table
                    striped
                    hover
                    :responsive="true"
                    :items="users"
                    :fields="fields">
                    <template v-slot:cell(full_name)="data">
                        <a href="#"
                           v-text="data.value"
                           @click="showModalUserProfile( data.item.id )">
                        </a>
                    </template>

                    <template v-slot:cell(doctor_memo)="data">
                        <span v-if="data.item.doctor_memos.length > 0">
                            {{ data.item.doctor_memos[0].doctor_memo }}
                        </span>
                    </template>

                    <template v-slot:cell(links)="data">
                        <div
                            class="nextButton"
                            @click="showModalDoctorReservationDoctorMenu(data.item)">
                            選択
                        </div>
                    </template>
                </b-table>

                <b-pagination
                    :total-rows="paginationConf.totalRows"
                    :per-page="paginationConf.perPage"
                    v-model="paginationConf.currentPage"
                    @change="fetchUsers">
                </b-pagination>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import { mapMutations } from 'vuex'

    export default {
        data: function () {
            return {
                modalShow: false,
                users: null,
                freeword: '',
                paginationConf: {
                    currentPage: 1,
                    perPage: 10,
                    totalRows: 0,
                },
                fields: [
                    {
                        'key': 'id',
                        'label': this.$locale.patient + '番号',
                    },
                    {
                        'key': 'full_name_kana',
                        'label': 'フリガナ',
                    },
                    {
                        'key': 'full_name',
                        'label': this.$locale.patient + '名',
                    },
                    {
                        'key': 'age',
                        'label': '年齢',
                    },
                    {
                        'key': 'doctor_memo',
                        'label': this.$locale.patient + 'メモ',
                    },
                    {
                        'key': 'links',
                        'label': '',
                    },
                ],
            }
        },

        created: function () {
            bus.$on('open-modal-doctor-reservation-user-search', this.open)
            bus.$on('close-modal-doctor-reservation-user-search', this.close)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-reservation-user-search')
            bus.$off('close-modal-doctor-reservation-user-search')
        },

        methods: {
            /**
             * モーダル表示
             *
             * @param {boolean} initialize
             */
            open: function (initialize = true) {
                if (initialize) {
                    this.fetchUsers()
                }
                this.modalShow = true
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.modalShow = false
            },

            /**
             * 患者一覧取得
             *
             * @param {number} param
             */
            fetchUsers: function (param = 1) {
                this.users = null
                this.paginationConf.currentPage = typeof param === 'number' ? param : 1

                let endpoint = constants.doctor.users.endpoint.base
                endpoint += `?page=${this.paginationConf.currentPage}`

                if (this.freeword && this.freeword.length > 0) {
                    endpoint += `&freeword=${this.freeword}`
                }

                axios.get(endpoint)
                    .then(({data}) => {
                        this.users = data.data
                        this.paginationConf.perPage = data.per_page
                        this.paginationConf.totalRows = data.total
                    });
            },

            /**
             * 会員詳細モーダル表示
             *
             * @return {void}
             */
            showModalUserProfile: function (user_id) {
                bus.$emit('open-modal-user-profile', user_id, null, 'search')
            },

            /**
             * 会員診療予約モーダル表示
             *
             * @param {object} user
             */
            showModalDoctorReservationDoctorMenu: function (user) {
                this.setUser(user)
                bus.$emit('open-modal-doctor-reservation-doctor-menu')
            },

            ...mapMutations({
                setUser: 'doctorReservation/setUser',
            }),
        },
    }
</script>

<style scoped lang="scss">
    .c-freeword {
        max-width: 300px;

        .c-freeword__btn {
            cursor: pointer;
        }
    }
</style>

<style lang="scss" scoped>
.p-user-search {
    .b-table {
        th {
            font-size: .8rem;

            &:nth-child(1) {
                min-width: 78px;
            }

            &:nth-child(2) {
                min-width: 120px;
            }

            &:nth-child(3) {
                min-width: 100px;
            }

            &:nth-child(4) {
                min-width: 50px;
            }
        }

        td {
            font-size: .8rem;
        }
    }
}

.nextButton {
    display: block;
    padding: 4px 12px;
    margin: 0 auto;
    color: #fff;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    box-sizing: border-box;

    &:disabled {
        cursor: default;
    }
}
</style>
